import { isRejectedWithValue } from '@reduxjs/toolkit';
import { PERMISSION_DENIED_CODE } from './permission-base-query';
import { permissionRequestDenied } from '../store/permissionGateSlice';

/**
 * Redux middleware: broadcasts every permission-denied API settlement into
 * `permissionGate.lastDenied`. Lets hooks/components reset loading or local
 * state centrally without per-component permission handling.
 *
 * Runs in parallel with the existing modal/batching pipeline:
 *   - `permission-base-query.js`  -> returns the rejected payload + opens modal
 *   - this listener               -> records the settlement on the slice
 *
 * Safe to add alongside `rtkQueryErrorLogger`; both are pure pass-throughs
 * for permission-denied actions and do not interfere with each other.
 */
export const permissionDeniedListener = (store) => (next) => (action) => {
  const result = next(action);

  if (
    isRejectedWithValue(action) &&
    action?.payload?.data?.code === PERMISSION_DENIED_CODE
  ) {
    const meta = action.meta || {};
    const baseQueryRequest = meta.baseQueryMeta?.request;

    store.dispatch(
      permissionRequestDenied({
        endpoint: meta.arg?.endpointName ?? null,
        requestId: meta.requestId ?? null,
        requiredPermission: action.payload?.data?.requiredPermission ?? null,
        method: baseQueryRequest?.method ?? null,
        url: baseQueryRequest?.url ?? null,
        ts: Date.now(),
      }),
    );
  }

  return result;
};

export default permissionDeniedListener;
